/* eslint-disable */
/* tslint:disable */
/* auto-generated react proxies */
import { createReactComponent } from './react-component-lib';

import type { JSX } from '@agilepoint/web-components';

import { defineCustomElements } from '@agilepoint/web-components/loader';

defineCustomElements();
export const ApIcon = /*@__PURE__*/createReactComponent<JSX.ApIcon, HTMLApIconElement>('ap-icon');
export const ApIllustration = /*@__PURE__*/createReactComponent<JSX.ApIllustration, HTMLApIllustrationElement>('ap-illustration');
export const ApResolutionGuard = /*@__PURE__*/createReactComponent<JSX.ApResolutionGuard, HTMLApResolutionGuardElement>('ap-resolution-guard');
export const ApSvgSprite = /*@__PURE__*/createReactComponent<JSX.ApSvgSprite, HTMLApSvgSpriteElement>('ap-svg-sprite');
